import { RouterProvider } from "react-router-dom";
import router from "./routes";
import "./style/index.css";
import "./style/form.scss";
import { useTranslation } from "react-i18next";

function App() {
  const { i18n } = useTranslation();
  return (
    <div
      className={`App ${i18n.language === "ar" ? "body-rtl" : ""}`}
      style={{ height: "100vh" }}
    >
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
